import React from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {
  StyledContainer,
  StyledBlocksContainer,
} from './styled';
import Learnings from './components/Learnings';
import { learningFromLastMatch } from '../../redux/selector/Home';

const TipsInNotif = () => {
  const learnings = useSelector(learningFromLastMatch);
  return (
    <StyledContainer>
      {!isEmpty(learnings) ? (
        <StyledBlocksContainer>
          <Learnings learnings={learnings} />
        </StyledBlocksContainer>
      ) : (
        <h4>No new learnings yet. Come back after the first match.</h4>
      )}
    </StyledContainer>
  );
};

export default TipsInNotif;
